<template>
    <div @scroll="handleScroll">
      <!-- MENU -->
      <MenuSection
        :color="color"
        :logo="logo"
        :key="color"
        :active-route="activeRoute"
        @update-active-route="setActiveRoute"
        @update-language="setActiveLanguage"
        :active-language="activeLanguage"
      />
  
      <section class="casos-section">
        <div class="casos-container">
  
          <!-- Header -->
          <div class="casos-header">
            <p class="eyebrow">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                <polyline points="17 6 23 6 23 12"/>
              </svg>
              {{ translations.success.success_text }}
            </p>
            <h3>{{ translations.success.title }}</h3>
            <p class="subheading">
              {{ translations.success.subtitle }}
            </p>
          </div>
  
          <!-- Blog entries -->
          <div class="entries">
            <div
              v-for="(caso, index) in translations.success.casos"
              :key="index"
              class="entry"
              @click="openModal(index)"
            >
              <div class="entry-sidebar">
                <div>
                  <p class="entry-label">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                      <polyline points="17 6 23 6 23 12"/>
                    </svg>
                    {{ translations.success.success_text_single }}
                  </p>
                  <!-- <div class="entry-accent"></div> -->
                  <p class="entry-roman">{{ caso.num }}</p>
                </div>
                <p class="entry-category">{{ caso.tag }}</p>
              </div>
  
              <div class="entry-content">
                <div>
                  <span class="entry-tag">{{ caso.tag }}</span>
                  <p class="entry-title">{{ caso.title }}</p>
                  <p class="entry-excerpt">{{ caso.excerpt }}</p>
                </div>
                <div class="entry-footer">
                  <!-- <div class="entry-insight">
                    <div class="insight-dot"></div>
                    <p class="insight-text">{{ caso.insight }}</p>
                  </div> -->
                  <div class="read-btn">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <line x1="5" y1="12" x2="19" y2="12"/>
                      <polyline points="12 5 19 12 12 19"/>
                    </svg>
                    {{ translations.success.read }}
                  </div>
                </div>
              </div>
            </div>
          </div>
  
        </div>
      </section>
  
      <!-- Modal -->
      <transition name="fade">
        <div
          v-if="activeModal !== null"
          class="modal-overlay"
          @click.self="closeModal"
        >
          <div class="modal">
            <div class="modal-top">
              <div class="modal-sidebar">
                <p class="modal-label">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                    <polyline points="17 6 23 6 23 12"/>
                  </svg>
                  {{translations.success.success_text_single}}
                </p>
                <!-- <div class="modal-accent"></div> -->
                <p class="modal-roman">{{ translations.success.casos[activeModal].num }}</p>
                <p class="modal-cat">{{ translations.success.casos[activeModal].tag }}</p>
              </div>
              <div class="modal-right">
                <span class="modal-tag">{{ translations.success.casos[activeModal].tag }}</span>
                <p class="modal-title">{{ translations.success.casos[activeModal].title }}</p>
                <div class="modal-body" v-html="translations.success.casos[activeModal].body"></div>
                <!-- <div class="modal-insight">
                  <div class="modal-insight-dot"></div>
                  <p class="modal-insight-text">{{ translations.success.casos[activeModal].insight }}</p>
                </div> -->
              </div>
            </div>
            <div class="modal-close-bar">
              <button class="close-btn" @click="closeModal">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
                {{ translations.success.close }}
              </button>
            </div>
          </div>
        </div>
      </transition>
  
    </div>
  </template>
  
  <script>
  import MenuSection from './MenuSection.vue'
  import esp from '../assets/json/es.json'
  import en from '../assets/json/en.json'
  
  export default {
    name: 'CasosExito',
    components: {
      MenuSection
    },
    data() {
      return {
        color: 'light',
        logo: require('../assets/img/img_logo_color.svg'),
        activeRoute: localStorage.getItem('activeRoute') || 'home',
        activeLanguage: localStorage.getItem('selectedLanguage') || 'eng',
        translations: localStorage.getItem('selectedLanguage') === 'esp' ? esp : en,
        activeModal: null,
        casos: [
          {
            num: 'I',
            tag: 'Consumo masivo',
            title: 'Cómo la inteligencia del consumidor ayudó a destrabar la entrada de una marca en Baja California',
            excerpt: 'Cuando una marca nacional de leche decidió fortalecer su presencia en Baja California, la respuesta del mercado fue menor a la esperada. La barrera no estaba en el producto, sino en cómo era percibida por el consumidor local...',
            insight: 'Las barreras culturales pueden pesar más que el precio en la decisión de compra.',
            body: `<p>Cuando una marca nacional de leche decidió fortalecer su presencia en Baja California, partía de una premisa lógica: su posicionamiento en otras regiones del país podía facilitar la adopción del producto. Sin embargo, la respuesta inicial del mercado fue menor a la esperada. La empresa enfrentaba una barrera que no parecía estar en el producto, sino en la forma en que era percibida por el consumidor local.</p>
                   <p>FOCUS diseñó un estudio cualitativo con consumidores de la región para entender qué estaba frenando la compra. A través de sesiones de grupo, detectamos un hallazgo clave: el consumo de leche estaba fuertemente vinculado con la identidad regional y con una lealtad histórica hacia marcas locales. En ese contexto, la marca era vista como una empresa externa que competía con algo considerado propio.</p>
                   <p>Ese insight permitió replantear la lectura del problema. No se trataba únicamente de distribución, precio o recordación, sino de una barrera emocional y cultural que estaba afectando la aceptación de la marca en el punto de decisión.</p>
                   <p>Con base en esta evidencia, la empresa ajustó su comunicación para conectar con referentes identitarios de Baja California y reducir la percepción de lejanía, generando mejores condiciones para la aceptación del producto.</p>
                   <p>Este caso muestra cómo la inteligencia de mercado puede revelar tensiones culturales invisibles a primera vista y convertirlas en criterios útiles para redefinir una estrategia comercial.</p>`
          },
          {
            num: 'II',
            tag: 'Industrial / B2B',
            title: 'Cómo identificar demanda cercana permitió activar capacidad instalada ociosa',
            excerpt: 'Una empresa fabricante de preformas de PET enfrentaba capacidad ociosa. El reto era encontrar nuevos clientes dentro de un radio logístico viable sin partir de supuestos...',
            insight: 'La investigación puede convertirse en herramienta directa para encontrar demanda y mejorar el desempeño operativo.',
            body: `<p>Una empresa fabricante de preformas de PET había instalado su operación junto a una planta embotelladora relevante para atender de manera eficiente a su cliente principal. Con el tiempo, la operación comenzó a mostrar capacidad ociosa y el reto se volvió evidente: encontrar nuevos clientes dentro de un radio logístico viable para aprovechar mejor la infraestructura existente.</p>
                   <p>FOCUS desarrolló una investigación aplicada al mercado real. En lugar de partir de supuestos, realizamos un levantamiento sistemático en supermercados, tiendas, centros de distribución y puntos de consumo para identificar productos envasados en PET, marcas activas en la región y posibles responsables de producción o embotellado.</p>
                   <p>El trabajo no solo permitió mapear categorías y competidores. También ayudó a detectar oportunidades comerciales concretas, documentar prospectos viables y construir una lectura clara del mercado accesible para la planta.</p>
                   <p>Con esa información, la empresa pudo abrir nuevas conversaciones comerciales dentro de su radio logístico eficiente, diversificar su cartera y aprovechar mejor su capacidad instalada en periodos antes improductivos.</p>
                   <p>Este caso demuestra que la inteligencia de mercado no solo sirve para entender consumidores; también puede convertirse en una herramienta directa para encontrar demanda, ampliar mercado y mejorar el desempeño operativo.</p>`
          },
          {
            num: 'III',
            tag: 'Marca deportiva',
            title: 'Cómo la investigación cultural ayudó a construir pertenencia para una nueva marca deportiva',
            excerpt: 'El lanzamiento de un nuevo equipo profesional en Tijuana tenía visibilidad, pero no arraigo. La ciudad ya tenía aficionados con identidad futbolera formada alrededor de otros clubes...',
            insight: 'La dimensión cultural de la investigación construye identidad y arraigo en categorías altamente emocionales.',
            body: `<p>El lanzamiento de un nuevo equipo profesional en Tijuana partía con inversión, visibilidad y entusiasmo inicial. Sin embargo, eso no garantizaba arraigo. La ciudad ya contaba con aficionados cuya identidad futbolera se había formado durante años alrededor de otros clubes, por lo que el verdadero reto no era solo atraer atención, sino construir pertenencia.</p>
                   <p>Para entender esa dinámica, FOCUS desarrolló un proceso de investigación cualitativa profunda con aficionados locales. Combinamos sesiones grupales con exploración de hábitos, rituales, símbolos y emociones asociados al fútbol, con el objetivo de identificar qué elementos podían conectar a la comunidad con una nueva marca deportiva.</p>
                   <p>El estudio permitió distinguir los códigos culturales que activaban identificación real en la afición y separarlos de los mensajes que solo generaban interés superficial. Esa lectura ayudó a comprender que, para construir lealtad, la marca necesitaba hablar desde la identidad de la ciudad y no únicamente desde la novedad del proyecto.</p>
                   <p>Con base en estos hallazgos, el equipo responsable de comunicación y marketing contó con criterios más claros para alinear su narrativa, fortalecer símbolos de pertenencia y desarrollar una conexión más auténtica con la comunidad local.</p>
                   <p>Este caso muestra cómo la inteligencia de mercado, aplicada desde una dimensión cultural, puede ayudar a construir identidad, arraigo y relevancia para una nueva marca en una categoría altamente emocional.</p>`
          },
          {
            num: 'IV',
            tag: 'Retail / Marca propia',
            title: 'Cómo la investigación ayudó a reposicionar una marca propia dentro del retail',
            excerpt: 'Una cadena de autoservicio tenía una marca propia con presencia débil en tienda. El problema no era visibilidad: era la falta de claridad en su propuesta de valor frente a otras opciones...',
            insight: 'La investigación convierte una marca sub aprovechada en activo estratégico con claridad de reposicionamiento.',
            body: `<p>Una importante cadena de autoservicio de la región contaba desde hacía años con una marca propia dentro de su portafolio. A pesar de ello, su presencia en tienda era débil, su percepción era limitada y no funcionaba como un activo claro de diferenciación ni de valor para el negocio.</p>
                   <p>FOCUS desarrolló un diagnóstico integral para entender qué estaba frenando su crecimiento. La primera etapa incorporó investigación cuantitativa con clientes para evaluar percepción de calidad, precio, confianza y disposición de compra. En una segunda fase, profundizamos cualitativamente en las asociaciones, atributos y barreras emocionales que estaban definiendo la relación del consumidor con la marca.</p>
                   <p>El análisis permitió identificar no solo las razones de su bajo desempeño, sino también el espacio estratégico que podía ocupar dentro del anaquel. La investigación mostró que el problema no era simplemente de visibilidad, sino de construcción de valor y de claridad en su propuesta frente a otras opciones de la tienda.</p>
                   <p>Con base en estos hallazgos, la cadena decidió conservar el nombre de la marca, pero rediseñar su imagen y redefinir su propuesta de valor. El cambio permitió fortalecer su presencia en el punto de venta y empujar un reposicionamiento más aspiracional dentro del portafolio.</p>
                   <p>Este caso demuestra que la inteligencia de mercado puede convertir una marca sub aprovechada en un activo estratégico cuando aporta claridad sobre percepción, barreras y oportunidades reales de reposicionamiento.</p>`
          },
          {
            num: 'V',
            tag: 'Inmobiliario',
            title: 'Cómo la inteligencia de mercado ayudó a rediseñar una inversión inmobiliaria de alto riesgo',
            excerpt: 'Antes de lanzar un desarrollo residencial en Cabo San Lucas, la desarrolladora necesitaba validar si su propuesta de ticket alto respondía realmente a la dinámica del mercado...',
            insight: 'La inteligencia de mercado también evita inversiones costosas al revelar la demanda real y el riesgo.',
            body: `<p>Antes de lanzar un nuevo desarrollo residencial en Cabo San Lucas, una desarrolladora buscaba validar si su propuesta respondía realmente a la dinámica del mercado. El concepto inicial contemplaba viviendas de ticket alto, terrenos amplios, amenidades premium y un posicionamiento orientado a un segmento superior a los 500 mil dólares.</p>
                   <p>FOCUS estructuró la evaluación en dos frentes. Primero realizamos investigación documental del mercado inmobiliario local para analizar oferta existente, niveles de precio, amenidades, absorción y velocidad de venta. Después contrastamos esa lectura con entrevistas a agentes inmobiliarios especializados, quienes aportaron una visión directa sobre comportamiento de compradores, demanda activa y viabilidad comercial del concepto.</p>
                   <p>La evidencia mostró una señal crítica: el segmento contemplado por el proyecto presentaba una demanda más limitada y una velocidad de comercialización más lenta, lo que elevaba el riesgo financiero de la inversión. En cambio, identificamos una franja de precio con mayor dinamismo, mejor absorción y una oportunidad comercial más atractiva para el desarrollo.</p>
                   <p>Con base en esa lectura, recomendamos rediseñar el proyecto hacia un rango de precio más alineado con la realidad del mercado. La decisión permitió reducir exposición a un segmento de menor tracción y reencauzar la inversión hacia una propuesta con mejores condiciones de salida comercial.</p>
                   <p>Este caso confirma que la inteligencia de mercado no solo sirve para impulsar proyectos; también puede evitar decisiones de inversión costosas cuando aporta claridad sobre demanda real, velocidad de mercado y riesgo.</p>`
          }
        ]
      }
    },
    computed: {
      dynamicClass() {
        return this.activeLanguage === 'esp' ? 'espacio2' : 'espacio'
      }
    },
    mounted() {
      const savedLanguage = localStorage.getItem('selectedLanguage')
      if (savedLanguage) {
        this.setActiveLanguage(savedLanguage)
      } else {
        this.translations = this.activeLanguage === 'eng' ? esp : en
      }
      window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      setActiveRoute(route) {
        this.activeRoute = route
        localStorage.setItem('activeRoute', route)
      },
      setActiveLanguage(language) {
        this.activeLanguage = language
        this.translations = language === 'eng' ? en : esp
        localStorage.setItem('selectedLanguage', language)
      },
      handleScroll() {
        const sections = document.querySelectorAll('.section')
        let currentSection = null
        sections.forEach(section => {
          const rect = section.getBoundingClientRect()
          if (rect.top <= 50 && rect.bottom >= 50) {
            currentSection = section
          }
        })
        if (currentSection) {
          this.toggleColor(currentSection)
        }
      },
      toggleColor(section) {
        if (section.classList.contains('dark')) {
          this.color = 'dark'
          this.logo = require('../assets/img/img_logo_white.svg')
        } else {
          this.color = 'light'
          this.logo = require('../assets/img/img_logo_color.svg')
        }
      },
      openModal(index) {
        this.activeModal = index
        document.body.style.overflow = 'hidden'
      },
      closeModal() {
        this.activeModal = null
        document.body.style.overflow = ''
      }
    }
  }
  </script>
  
  <style scoped>
  
  /* ── Sección principal ── */
  .casos-section {
    padding: 10rem 0;
  }
  
  .casos-container {
    max-width: 860px;
    margin: 0 auto;
    padding: 0 2rem;
  }
  
  /* ── Header ── */
  .casos-header {
    margin-bottom: 2.5rem;
  }
  
  .eyebrow {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #1D9E75;
    margin-bottom: 0.6rem;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  
  h3 {
    font-size: 40px;
    font-weight: 600;
    line-height: 45px;
    color: #01146E;
    margin-bottom: 0.5rem;
  }
  
  .subheading {
    font-size: 14px;
    color: #666;
    line-height: 1.65;
    max-width: 500px;
  }
  
  /* ── Entries ── */
  .entries {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  .entry {
    display: flex;
    border-radius: 14px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.08);
    cursor: pointer;
    background: #fff;
    transition: box-shadow 0.25s ease, transform 0.25s ease;
  }
  
  .entry:hover {
    box-shadow: 0 6px 24px rgba(1, 20, 110, 0.12);
    transform: translateY(-2px);
  }
  
  /* ── Sidebar de entrada ── */
  .entry-sidebar {
    width: 160px;
    min-width: 160px;
    background: #01146E;
    padding: 1.5rem 1.25rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .entry-label {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #1D9E75;
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 0 0 0.6rem;
  }
  
  .entry-accent {
    width: 3px;
    height: 28px;
    background: #fff;
    border-radius: 2px;
    margin: 0.4rem 0;
  }
  
  .entry-roman {
    font-size: 52px;
    font-weight: 700;
    color: #fff;
    line-height: 1;
    margin: 0.25rem 0 0;
  }
  
  .entry-category {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.65);
    line-height: 1.4;
    margin: 0;
  }
  
  /* ── Contenido de entrada ── */
  .entry-content {
    flex: 1;
    padding: 1.5rem 1.75rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .entry-tag {
    display: inline-block;
    font-size: 10px;
    font-weight: 500;
    color: #0F6E56;
    background: #E1F5EE;
    padding: 3px 10px;
    border-radius: 99px;
    margin-bottom: 0.75rem;
  }
  
  .entry-title {
    font-size: 16px;
    font-weight: 600;
    color: #01146E;
    line-height: 1.4;
    margin: 0 0 0.75rem;
  }
  
  .entry-excerpt {
    font-size: 13px;
    color: #555;
    line-height: 1.75;
    margin: 0 0 1.25rem;
  }
  
  /* ── Footer de entrada ── */
  .entry-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  
  .entry-insight {
    display: flex;
    align-items: flex-start;
    gap: 7px;
    flex: 1;
  }
  
  .insight-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #1D9E75;
    flex-shrink: 0;
    margin-top: 4px;
  }
  
  .insight-text {
    font-size: 11px;
    color: #0F6E56;
    font-weight: 500;
    line-height: 1.4;
    margin: 0;
  }
  
  .read-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    font-weight: 500;
    color: #01146E;
    white-space: nowrap;
    flex-shrink: 0;
    border: 1px solid rgba(1, 20, 110, 0.25);
    border-radius: 8px;
    padding: 6px 14px;
    transition: background 0.18s, color 0.18s;
  }
  
  .entry:hover .read-btn {
    background: #01146E;
    color: #fff;
  }
  
  /* ── Modal overlay ── */
  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(1, 20, 110, 0.45);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
  }
  
  /* ── Modal ── */
  .modal {
    position: relative !important;
    background: #fff;
    border-radius: 16px;
    max-width: 720px;
    width: 100%;
    max-height: 85vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 60px rgba(1, 20, 110, 0.25);
  }
  
  .modal-top {
    display: flex;
    flex: 1;
    overflow: hidden;
  }
  
  /* ── Modal sidebar ── */
  .modal-sidebar {
    width: 160px;
    min-width: 160px;
    background: #01146E;
    padding: 1.75rem 1.25rem;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
  
  .modal-label {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #1D9E75;
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 0 0 0.5rem;
  }
  
  .modal-accent {
    width: 3px;
    height: 30px;
    background: #fff;
    border-radius: 2px;
    margin: 0.5rem 0;
  }
  
  .modal-roman {
    font-size: 56px;
    font-weight: 700;
    color: #fff;
    line-height: 1;
    margin: 0.25rem 0;
  }
  
  .modal-cat {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.65);
    margin: 0;
    line-height: 1.4;
  }
  
  /* ── Modal contenido ── */
  .modal-right {
    flex: 1;
    padding: 1.75rem 1.75rem;
    overflow-y: auto;
  }
  
  .modal-tag {
    display: inline-block;
    font-size: 10px;
    font-weight: 500;
    color: #0F6E56;
    background: #E1F5EE;
    padding: 3px 10px;
    border-radius: 99px;
    margin-bottom: 0.75rem;
  }
  
  .modal-title {
    font-size: 19px;
    font-weight: 600;
    color: #01146E;
    line-height: 1.4;
    margin: 0 0 1.25rem;
  }
  
  .modal-body /deep/ p {
    font-size: 13px;
    color: #555;
    line-height: 1.8;
    margin: 0 0 0.9rem;
  }
  
  .modal-body /deep/ p:last-child {
    margin-bottom: 0;
  }
  
  .modal-insight {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background: #E1F5EE;
    border-radius: 8px;
    padding: 0.75rem 1rem;
    margin-top: 1.25rem;
  }
  
  .modal-insight-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #1D9E75;
    margin-top: 4px;
    flex-shrink: 0;
  }
  
  .modal-insight-text {
    font-size: 12px;
    color: #0F6E56;
    font-weight: 500;
    line-height: 1.5;
    margin: 0;
  }
  
  /* ── Modal close bar ── */
  .modal-close-bar {
    padding: 0.75rem 1.25rem;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
  }
  
  .close-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 500;
    color: #555;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    padding: 6px 16px;
    background: none;
    cursor: pointer;
    transition: background 0.15s;
  }
  
  .close-btn:hover {
    background: #f5f5f5;
  }
  
  /* ── Transición del modal ── */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s ease;
  }
  
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  
  /* ── Responsive ── */
  @media (max-width: 640px) {
    h3 {
      font-size: 28px;
      line-height: 34px;
    }
  
    .entry {
      flex-direction: column;
    }
  
    .entry-sidebar {
      width: 100%;
      min-width: unset;
      flex-direction: row;
      align-items: center;
      padding: 1rem 1.25rem;
      gap: 12px;
    }
  
    .entry-accent {
      display: none;
    }
  
    .entry-roman {
      font-size: 32px;
    }
  
    .entry-content {
      padding: 1.25rem;
    }
  
    .modal-overlay {
      padding: 1rem;
      align-items: flex-end;
    }
  
    .modal {
      max-height: 90vh;
      border-radius: 16px 16px 0 0;
    }
  
    .modal-top {
      flex-direction: column;
    }
  
    .modal-sidebar {
      width: 100%;
      min-width: unset;
      flex-direction: row;
      align-items: center;
      padding: 1rem 1.25rem;
      gap: 12px;
    }
  
    .modal-accent {
      display: none;
    }
  
    .modal-roman {
      font-size: 32px;
    }
  
    .entry-footer {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
  }
  </style>
  